export const SectionLabel = ({ children, dark = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className={`h-px w-8 ${dark ? "bg-teal" : "bg-ink/30"}`} />
    <span
      className={`font-mono uppercase text-xs tracking-[0.25em] ${
        dark ? "text-teal" : "text-ink"
      }`}
    >
      {children}
    </span>
  </div>
);
